/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import BaseFrame from "../../../../component/wrapper/BaseFrame";
import { HomeLink } from "../../../../component/breadcrums/Links";
import SompoLoading from "../../../../component/loading/SompoLoading";
import NoData from "../../../../component/NoData";

import { showErrorMessage } from "../../../../logic/hook/useDialogStateHelper";
import TestEnqueteHistoryListService, {
    TestEnqueteListItem,
    TestEnqueteHistoryListResponse,
} from "../../../../logic/api/TestEnqueteHistoryListService";
import SompoContext from "../../../../logic/context/SompoContext";

const testEnqueteHistoryListService = new TestEnqueteHistoryListService();

// 実際に表示されるコンポーネント
const Content = () => {
    const { careerId, classId } = useParams(); // テストアンケート履歴一覧取得用
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用
    const [openRows, setOpenRows] = React.useState<{ [key: string]: boolean }>({}); // 開閉状態管理用
    const [testHistoryList, setTestHistoryList] = useState<TestEnqueteListItem[]>([]); // テストアンケート履歴一覧取得用

    // 初期表示時にテストアンケート履歴一覧を取得
    useEffect(() => {
        sompoContext.setLoading(true); // ローディング開始
        const fetch = async () => {
            await testEnqueteHistoryListService.testEnqueteHistoryList(
                { careerId: careerId!, classId: classId! },
                (_testEnqueteHistoryList: TestEnqueteHistoryListResponse) => {
                    setTestHistoryList(_testEnqueteHistoryList.testEnqueteList);
                    sompoContext.setLoading(false); // ローディング修了
                },
                (error: any) => {
                    console.error(error);
                    sompoContext.setLoading(false);
                    setTestHistoryList([]);
                    showErrorMessage({ message: "テストアンケート履歴一覧の取得に失敗しました。", error });
                }
            );
        };
        fetch();
    }, []);

    // セルのスタイル
    const StyledTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            // ヘッダー部分
            backgroundColor: "#CCCCCC",
            textAlign: "center",
        },
        [`&.${tableCellClasses.body}`]: {
            // body部分
            wordBreak: "break-all",
        },
        // 共通部分
        border: "1px solid #999",
        backgroundColor: "#fff",
    }));

    // 二階層目の開閉
    const handleOpenRows = (index: string) => {
        setOpenRows({ ...openRows, [index]: !openRows[index] });
    };

    return (
        <Box sx={{ width: "100%", minHeight: "400px", position: "relative" }}>
            {/* fetchが終わるまでローディングアイコンを表示 */}
            {sompoContext.loading ? (
                <SompoLoading />
            ) : (
                <TableContainer sx={{ mb: 8 }}>
                    <Table
                        sx={{
                            minWidth: 650,
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <StyledTableCell
                                    sx={{
                                        width: "70px",
                                        maxWidth: "70px",
                                    }}
                                />
                                <StyledTableCell>
                                    <Typography variant="h5">タイトル</Typography>
                                </StyledTableCell>
                                <StyledTableCell sx={{ width: "150px" }}>
                                    <Typography variant="h5">種別</Typography>
                                </StyledTableCell>
                                <StyledTableCell sx={{ width: "150px" }}>
                                    <Typography variant="h5">履歴件数</Typography>
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(testHistoryList || []).length > 0 ? (
                                <>
                                    {testHistoryList?.map((testHistoryListItem, index) => (
                                        <React.Fragment key={index}>
                                            <TableRow
                                                hover
                                                onClick={() => handleOpenRows(String(index))}
                                                sx={{
                                                    transition: "all 0.2s ease-in-out",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <StyledTableCell>
                                                    <IconButton>
                                                        {openRows[String(index)] ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                                                    </IconButton>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Typography variant="h6">{testHistoryListItem.title}</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Typography variant="h6"> {testHistoryListItem.kind}</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell sx={{ textAlign: "right" }}>
                                                    <Typography variant="h6">{testHistoryListItem.historyCount}</Typography>
                                                </StyledTableCell>
                                            </TableRow>
                                            <TableCell sx={{ p: 0, borderRight: "1px solid #999", borderLeft: "1px solid #999" }} colSpan={4}>
                                                <Collapse
                                                    timeout="auto"
                                                    unmountOnExit
                                                    in={openRows[String(index)]}
                                                    sx={{ borderBottom: "1px solid #999", bgcolor: "#fff" }}
                                                >
                                                    <Box sx={{ m: 4 }}>
                                                        {(testHistoryListItem.historyList || []).length > 0 ? (
                                                            <Table>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <StyledTableCell sx={{ bgcolor: "pink !important" }}>
                                                                            <Typography variant="h5">開始日時</Typography>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell sx={{ bgcolor: "pink !important" }}>
                                                                            <Typography variant="h5">修了日時</Typography>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell sx={{ bgcolor: "pink !important" }}>
                                                                            <Typography variant="h5">得点</Typography>
                                                                        </StyledTableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {testHistoryListItem.historyList.map((historyListItem, index2) => (
                                                                        <TableRow key={index2}>
                                                                            <StyledTableCell>
                                                                                <Typography variant="h6">{historyListItem.startDate}</Typography>
                                                                            </StyledTableCell>
                                                                            <StyledTableCell>
                                                                                <Typography variant="h6"> {historyListItem.endDate}</Typography>
                                                                            </StyledTableCell>
                                                                            <StyledTableCell sx={{ textAlign: "right" }}>
                                                                                <Typography variant="h6">{historyListItem.tokuten}</Typography>
                                                                            </StyledTableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        ) : (
                                                            <Typography variant="h6">履歴はありません</Typography>
                                                        )}
                                                    </Box>
                                                </Collapse>
                                            </TableCell>
                                        </React.Fragment>
                                    ))}
                                </>
                            ) : (
                                <TableRow>
                                    <StyledTableCell colSpan={4} sx={{ textAlign: "center !important" }}>
                                        <NoData message="表示データがありません" />
                                    </StyledTableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

const SearchBySkill = () => <BaseFrame width="80%" title="テスト履歴" breadcrumbs={[<HomeLink />]} content={<Content />} />;

export default SearchBySkill;
